<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras">
        <div class="container">
          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-sm-6 offset-sm-3">
              <div class=" row">
                <div class="col-12 text-center">
                  <h1>Restablece tu contraseña</h1>
                </div>
              </div>
              <div class="row" v-if="correcto === true">
                <div class="formulario col-12 bgblanco rounded pt-3 pb-4">
                  <div class="col-12 pb-2 text-center">
                    Ingresa el correo electrónico registrado de tu cuenta y te
                    enviaremos un correo para recuperar tu contraseña.
                  </div>
                  <form method="post" @submit="submitFormulario($event)">
                    <label>
                      <input
                        type="password"
                        v-model="formpwd.pwd"
                        maxlength="100"
                        placeholder="Nueva Contraseña"
                        class="text-center"
                        required
                      />
                    </label>

                    <label>
                      <input
                        type="password"
                        v-model="formpwd.pwd2"
                        maxlength="100"
                        placeholder="Repetir Contraseña"
                        class="text-center"
                        required
                      />
                    </label>

                    <div class="text-center pt-2">
                      <button type="submit" class="submit btnnaranja">
                        ENVIAR
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div class="row" v-if="correcto === false">
                <div class="formulario col-12 bgblanco rounded pt-3 pb-4">
                  <div class="col-12 pb-2 text-center">
                    No tienes permiso para restablecer contraseña, haz el proceso de recuperación de nuevo por favor.
                  </div>
                  
                </div>
              </div>
              <div class="row p-1">
                <div class="col-12 text-center">
                  <router-link class="link" to="/"
                    >Regresar al login</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div class="container">
          <div class="row p-2">
            <div class="col-12 text-center">
              <div class="texto">
                <span class="px-1">
                  GAIG
                  <sup>&reg;</sup> 2021. {{version}}
                </span>

                
                
              </div>
            </div>
          </div>
        </div>
      </footer>
    </section>
    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "",
      tiposervicio: "",
      version: "",
      codigo: "",
      user_id:"",
      correcto: null,
      formpwd: {
        pwd: "",
        pwd2: "",
      },
    };
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    this.version = this.$store.state.version;
    AOS.init();
    

    this.codigo = this.$route.params.codigo;
    this.user_id = this.$route.params.user_id;

    this.consultaCodigo();
  },
  methods: {
    consultaCodigo(){

      console.log("consultando codigo");
      var vm = this;
      

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        user_id: this.user_id,
        codigo: this.codigo
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-codigo-restablecimiento.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.correcto = true;

            } else if (res.status == "notok") {
              //swal.fire("Oops", res.msg, "warning");
              this.correcto = false;
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();


      //revisar longitud, alfanumerico y mayúsculas
      if (!this.formpwd.pwd.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{15,}$/)) {
        swal.fire(
          "Cambiar contraseña",
          "La contraseña debe de tener al menos 15 caracteres alfanúmericos, al menos 1 número y al menos una mayúscula. Ej. contraGAIG76483",
          "warning"
        );
        return;
      }

      if(this.formpwd.pwd != this.formpwd.pwd2){
        swal.fire(
          "Cambiar contraseña",
          "El campo de verificación de contraseña no coincide.",
          "warning"
        );
        return;
      }

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        user_id: this.user_id,
        codigo: this.codigo,
        pwd: this.formpwd.pwd
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "restablecer-contrasena.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              
              this.email = "";

              swal
                .fire({
                  title: "Restablecer contraseña",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    this.$router.push("/");
                  }
                });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

      //this.$router.push("/");
    },
  },
};
</script>

